import './Steps.scss';
import { Box, Button } from '@mui/material';
import {
  Handshake,
  Explore,
  FactCheck,
  Build,
  Verified,
  Tune,
  FlightTakeoff
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Steps = ({ data, navOpen, drupalData, drupalData1 }) => {
  const { i18n } = useTranslation();
  const stepIcons = [
    FactCheck,
    Handshake,
    Explore,
    Build,
    Verified,
    Tune,
    FlightTakeoff
  ];
  const navigate = useNavigate();
  return (
    data && (
      <>
        <div className={`gettingStartedContainer ${navOpen && 'navOpen'}`}>
          {Array.isArray(drupalData1) &&
            drupalData1.map((box, i) => {
              const StepIcon = stepIcons[i % stepIcons.length];
              const step = box;
              return (
                <Box className={`steps step${i + 1}`} key={`step${i}`}>
                  <div className="stepBadge" aria-hidden="true">
                    {i + 1}
                  </div>
                  <StepIcon className={`stepIcon icon${i + 1}`} />{' '}
                  <h2 className="stepHeader" aria-describedby="stepDescription">
                    {step.title}
                  </h2>
                  <div dangerouslySetInnerHTML={{ __html: step.content }} />
                  {i === 0 && step.cta_button && (
                    <div style={{ display: 'flex', marginTop:"70px" }}>
                      <Button
                        variant="primary"
                        size="md"
                        tabIndex={0}
                        aria-label={data.ariaLabel}
                        sx={{ margin: '10px 0', marginLeft: 'auto' }}
                        onClick={() => {
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                          navigate(
                            `/${i18n.language}/seller-registration-form`
                          );
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            navigate(
                              `/${i18n.language}/seller-registration-form`
                            );
                          }
                        }}
                      >
                        {step.cta_button}
                      </Button>
                    </div>
                  )}
                </Box>
              );
            })}
          <section
            className="quickLinksContainer"
            aria-labelledby="drIntgQuickLinksId"
          >
            <div className="quickLinks">
              <h2 id="drIntgQuickLinksId">{data.quickLinks.header}</h2>
              <ul>
                {Array.isArray(drupalData) &&
                  drupalData[0]?.links.map((link, index) => (
                    <li key={index}>
                      <a
                        href={
                          link.path.includes('aircanada.com')
                            ? `${link.path}`
                            : `/${i18n.language}${link.path}`
                        }
                        {...(link.path.includes('http') && {
                          target: '_blank'
                        })}
                      >
                        {link.text}
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
          </section>{' '}
        </div>
      </>
    )
  );
};

export default Steps;
